import { useCallback } from 'react';
import { exportToExcel, exportToTXT } from '../../utils/emendas/exportHelpers';

/**
 * Hook para exportação de dados de emendas
 * @param {Array} data - Dados a serem exportados
 * @param {Array} columns - Colunas da tabela
 * @param {string} emendaType - Tipo de emenda (municipal ou estadual)
 */
export const useExcelExport = (data, columns, emendaType) => {
  const handleExportExcel = useCallback(() => {
    exportToExcel(data, columns, emendaType);
  }, [data, columns, emendaType]);

  const handleExportTXT = useCallback(() => {
    exportToTXT(data, columns, emendaType);
  }, [data, columns, emendaType]);

  return { handleExportExcel, handleExportTXT };
};
